export default {
  props: {
    margin: {
      type: Object,
      default: () => ({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }),
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/margin.js